import { Alert, useOpenModal } from "@/components/Modal/index.mjs";
import { RightCircleOutlined } from "@ant-design/icons";
import { css } from "@emotion/react";
import { Button, Collapse, Divider, Modal, Spin, Tabs } from "antd";
import React, { useEffect, useState, useRef, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import useApi from "../useApi.mjs";
import EventModal from "./EventModal.jsx";
import Hexagon from "./Hexagon.jsx";
import "./previewImage.less";
import http from "@/biz/http.mjs";
import normalizeUrl from "@/biz/normalizeUrl.mjs";
import { fileFromClipboard } from "@/script/file.mjs";
import { chooseFiles } from "@/script/file.mjs";
import openWindow from "@/script/openWindow.mjs";
import runAsync from "@/script/runAsync.mjs";
import { getNavObj } from "../util.js";

const cssUv = css({
	padding: 12,
	border: "1px solid transparent",
	cursor: "pointer",

	"&:hover": {
		backgroundColor: "rgba(45, 189, 255, .2)",
		border: "1px solid rgba(45, 189, 255, .5)",
		borderRadius: 4,
	},
});

const EventBtn = ({ btnData, modalRef }) => {
	const [bgSvg, setBgSvg] = useState("");
	const elementRef = useRef(null);
	const navigate = useNavigate();
	const openModal = useOpenModal();

	useEffect(() => {
		if (elementRef.current) {
			// 首次获取宽度
			const width = elementRef.current.offsetWidth;
			let height = elementRef.current.offsetHeight;
			height = height > 30 ? height : 30;
			if (!!btnData.views?.length) {
				setBgSvg(Hexagon(width, height, "#0099CC", "#0099CC"));
			} else {
				setBgSvg(Hexagon(width, height));
			}
		}
	}, [btnData]);

	const handleNav = (uvData) => {
		let navObj;
		if (uvData.bizNodeType == "UV") {
			navObj = getNavObj({ uvId: uvData.pkid });
		} else {
			navObj = getNavObj({ uiId: uvData.pkid });
		}
		// navigate(navObj);
		if (uvData.oprType == "POP") {
			// 使用 URLSearchParams 解析
			const searchParams = new URLSearchParams(navObj.search);
			// 将迭代器转换为对象
			const paramsObject = Object.fromEntries(searchParams.entries());
			openWindow(navObj.pathName, paramsObject, "_blank");
		} else {
			navigate(navObj);
		}
	};

	const handleFetchUv = async (data) => {
		const pkid = data.pkid;
		if (!data.views?.length) return;
		const res = data.views || [];
		const directViews = res.filter((item) => item.isDirect) || [];
		// 如果能力下直接挂载了指定的视图，就默认直接跳转
		if (!!directViews.length) {
			const uvData = directViews[0].data || directViews[0];
			handleNav({ ...uvData, oprType: directViews[0].oprType || "UI" });
			return;
		}

		const uiIds =
			res.map((item) => {
				if (item.bizNodeType == "UI") return item.pkid;
				if (item.bizNodeType == "UV") return item.uiId;
			}) || [];
		// 去重uiIds
		const uiIdSet = [...new Set(uiIds)];

		if (uiIdSet.length == 1) {
			if (res.length == 1) {
				const uvData = res[0];
				handleNav(uvData);
			} else {
				openModal(<ModalPreviewUv handleNav={handleNav} uvs={res} />);
			}
		} else {
			modalRef.current?.handleCtrlClick({
				type: "UE",
				id: pkid,
			});
		}
	};
	return (
		<div
			ref={elementRef}
			title={btnData.ueName}
			style={{
				color: !!btnData.views?.length ? "#fff" : "",
				maxWidth: "190px",
				display: "inline-block",
				width: "max-content",
				backgroundImage: `url('${bgSvg}')`,
				backgroundRepeat: "no-repeat",
				backgroundSize: "cover",
				padding: "6px 16px 4px",
				lineHeight: "20px",
				marginBottom: "8px",
				cursor: "pointer",
				textAlign: "center",
				verticalAlign: "top",
			}}
			onClick={(e) => {
				if (e.ctrlKey || e.metaKey) {
					// setIsModalOpen(true)
					// setMapData(btn.ueMap)
					modalRef.current?.handleCtrlClick({
						type: "UE",
						id: btnData.pkid,
					});
				} else {
					handleFetchUv(btnData);
				}
			}}
		>
			{btnData.ueName}
		</div>
	);
};

export const ModalPreviewUv = ({ uvs, handleNav, onOk, ...props }) => {
	const children = uvs.map((uv) => {
		const { pkid } = uv;

		const onClick = () => {
			handleNav(uv);
			onOk();
		};

		return (
			<div key={pkid} css={cssUv} onClick={onClick}>
				{uv.uiName}
				{uv.bizNodeType == "UV" && `(${uv.uvName})`}
			</div>
		);
	});

	return (
		<Alert title="预览界面视图" width={400} {...props}>
			{children}
		</Alert>
	);
};

// 图片预览组件（左侧图片，右侧操作按钮）
export default ({ current, uvObj, noBtns = false }) => {
	const api = useApi();
	const [actionData, setActionData] = useState([]);
	const modalRef = useRef(null);
	const [btnLoading, setBtnLoading] = useState(false);
	const [uploadFileId, setUploadFileId] = useState(null);
	const [uploading, setUploading] = useState(false);
	const params = new URLSearchParams(location.search.split("?")[1]);
	const prjPatternId = params.get("prjPatternId");
	const [imgKey, setImgKey] = useState(new Date().getTime());

	useEffect(() => {
		if (current && !noBtns) fetchData(current);
		setUploadFileId(null);
	}, [current]);

	const fetchData = async (id) => {
		setActionData([]);
		setBtnLoading(true);
		const data = await api.fetchUmues({ pkid: id });
		setActionData(data || []);
		setBtnLoading(false);
	};

	// 上传图片

	const handleUpload = async () => {
		const [file] = await chooseFiles.image();

		if (file) {
			uploadUi(file);
		}
	};

	const handlePasteClick = async (isEdit = false) => {
		const ext = "png";
		const type = "image/png";

		const file = await (async () => {
			try {
				return await fileFromClipboard(type, `${crypto.randomUUID()}.${ext}`);
			} catch (err) {
				Modal.error({ content: err.message });
				throw err;
			}
		})();

		if (!file) {
			Modal.error({ content: "未从剪贴板读取到图片数据" });
			return;
		}
		if (isEdit) {
			editorUI(file);
		} else {
			uploadUi(file);
		}
	};

	const { currentPageActions, parentActions } = useMemo(() => {
		const current = actionData.filter((item) => !item.parentFlag);
		const parent = actionData.filter((item) => item.parentFlag);
		return { currentPageActions: current, parentActions: parent };
	}, [actionData]);

	const groupByUeCat = (actions) => {
		const groups = {};
		actions.forEach((action) => {
			const cat = action.ueCat || "默认组";
			if (!groups[cat]) groups[cat] = [];
			groups[cat].push(action);
		});
		return groups;
	};

	const groupByUiName = (actions) => {
		// 按 uiName 分组（不带前缀）
		const groups = {};
		actions.forEach((action) => {
			const uiName = action.uiName || "默认组";
			if (!groups[uiName])
				groups[uiName] = {
					actions: [],
					children: {},
					ueCatGroups: {},
					ungroupedActions: [],
				};
			groups[uiName].actions.push(action);
		});

		// 在每个 uiName 组内按 ueCat 分组
		Object.values(groups).forEach((group) => {
			const ungroupedActions = [];
			const ueCatGroups = {};

			group.actions.forEach((action) => {
				if (action.ueCat) {
					if (!ueCatGroups[action.ueCat]) ueCatGroups[action.ueCat] = [];
					ueCatGroups[action.ueCat].push(action);
				} else {
					ungroupedActions.push(action);
				}
			});

			group.ungroupedActions = ungroupedActions;
			group.ueCatGroups = ueCatGroups;
		});

		// 构建层级结构
		const tree = {};
		Object.entries(groups).forEach(([uiName, group]) => {
			// 检查这个组的 actions 是否有 upperUiName
			const firstAction = group.actions[0];
			const upperUiName = firstAction?.upperUiName;

			if (upperUiName && groups[upperUiName]) {
				// 作为子节点挂载到父节点
				groups[upperUiName].children[uiName] = group;
			} else {
				// 作为顶层节点
				tree[uiName] = group;
			}
		});

		return tree;
	};

	const renderUeCatGroup = (actions) => {
		return (
			<div
				style={{
					display: "flex",
					flexDirection: "column",
					gap: "12px",
					alignItems: "center",
				}}
			>
				{actions.map((btn, index) => (
					<EventBtn btnData={btn} modalRef={modalRef} key={index} />
				))}
			</div>
		);
	};

	const renderUiComponentGroup = (uiName, group, level = 0) => {
		const hasChildren = Object.keys(group.children).length > 0;
		const hasUeCatGroups = Object.keys(group.ueCatGroups || {}).length > 0;
		const hasUngroupedActions = group.ungroupedActions?.length > 0;

		return (
			<Collapse.Panel
				header={
					<span
						style={{
							color: "#333",
							fontWeight: 600,
							letterSpacing: "0.5px",
							textTransform: "uppercase",
							fontSize: "11px",
						}}
					>
						{uiName}
					</span>
				}
				key={`ui-${uiName}-${level}`}
				style={{
					marginBottom: "8px",
					border: "none",
				}}
			>
				{/* 无 ueCat 的事件平铺在顶部 */}
				{hasUngroupedActions && (
					<div
						style={{
							display: "flex",
							flexDirection: "column",
							gap: "12px",
							alignItems: "center",
							marginBottom: hasUeCatGroups ? "12px" : 0,
						}}
					>
						{group.ungroupedActions.map((btn, index) => (
							<EventBtn btnData={btn} modalRef={modalRef} key={index} />
						))}
					</div>
				)}

				{/* 按 ueCat 分组的事件 */}
				{hasUeCatGroups && (
					<Collapse
						bordered={false}
						ghost
						style={{
							background: "#fff",
							marginTop: hasUngroupedActions ? "12px" : 0,
							paddingTop: hasUngroupedActions ? "12px" : 0,
							borderTop: hasUngroupedActions ? "1px solid #f0f0f0" : "none",
						}}
					>
						{Object.entries(group.ueCatGroups).map(([ueCatName, actions]) => (
							<Collapse.Panel
								header={
									<span
										style={{
											color: "#0099cc",
											fontWeight: 500,
											fontSize: "11px",
											letterSpacing: "0.5px",
											textTransform: "uppercase",
										}}
									>
										{ueCatName}
									</span>
								}
								key={`ueCat-${ueCatName}-${uiName}`}
								style={{
									marginBottom: "4px",
									border: "none",
								}}
							>
								{renderUeCatGroup(actions)}
							</Collapse.Panel>
						))}
					</Collapse>
				)}

				{hasChildren && (
					<Collapse
						bordered={false}
						ghost
												expandIcon={({isActive}) => {
							return <RightCircleOutlined style={{ transform: isActive ? "rotate(90deg)" : ''}} />;
						}}
						style={{
							background: "#fff",
							marginTop: "12px",
						}}
					>
						{Object.entries(group.children).map(([childUiName, childGroup]) =>
							renderUiComponentGroup(childUiName, childGroup, level + 1),
						)}
					</Collapse>
				)}
			</Collapse.Panel>
		);
	};

	const renderGroupedActions = (actions) => {
		// 分离普通事件和界面组件事件
		const normalActions = actions.filter(
			(action) => action.mark !== "界面组件",
		);
		const uiComponentActions = actions.filter(
			(action) => action.mark === "界面组件",
		);

		// 普通事件按 ueCat 分组
		const normalGroups = groupByUeCat(normalActions);
		const normalEntries = Object.entries(normalGroups).filter(
			([catName]) => catName !== "默认组" || normalGroups["默认组"]?.length > 0,
		);

		// 界面组件事件按 uiName 分组（树形结构）
		const uiComponentTree = groupByUiName(uiComponentActions);
		const uiComponentEntries = Object.entries(uiComponentTree);

		const defaultActiveKey =
			normalGroups["默认组"]?.length > 0 ? ["默认组"] : [];

		return (
			<>
				{/* 普通事件 */}
				{normalEntries.length > 0 && (
					<Collapse
						defaultActiveKey={defaultActiveKey}
						bordered={false}
						ghost
						style={{
							background: "#fff",
						}}
					>
						{normalEntries.map(([catName, buttons]) => (
							<Collapse.Panel
								header={
									<span
										style={{
											color: "#0099cc",
											fontWeight: 600,
											letterSpacing: "0.5px",
											textTransform: "uppercase",
											fontSize: "11px",
										}}
									>
										{catName}
									</span>
								}
								key={catName}
								style={{
									marginBottom: "8px",
									border: "none",
								}}
							>
								<div
									style={{
										display: "flex",
										flexDirection: "column",
										gap: "12px",
										alignItems: "center",
									}}
								>
									{buttons.map((btn, index) => (
										<EventBtn btnData={btn} modalRef={modalRef} key={index} />
									))}
								</div>
							</Collapse.Panel>
						))}
					</Collapse>
				)}

				{/* 分隔线 */}
				{normalEntries.length > 0 && uiComponentEntries.length > 0 && (
					<Divider
						style={{ margin: "16px 0", fontSize: "12px", color: "#666" }}
					>
						界面组件
					</Divider>
				)}

				{/* 界面组件事件 */}
				{uiComponentEntries.length > 0 && (
					<Collapse
						bordered={false}
						expandIcon={({isActive}) => {
							return <RightCircleOutlined style={{ transform: isActive ? "rotate(90deg)" : ''}} />;
						}}
						ghost
						style={{
							background: "#fff",
						}}
					>
						{uiComponentEntries.map(([uiName, group]) =>
							renderUiComponentGroup(uiName, group),
						)}
					</Collapse>
				)}
			</>
		);
	};

	const uploadUi = async (file) => {
		setUploading(true);
		const param = {
			files: [file],
			prjId: uvObj.prjId || params.get("prjId"),
			sVer: uvObj.sVer || params.get("sVer") || 1,
			pkid: uvObj.uiId,
		};
		const header = { headers: { "Content-Type": "multipart/form-data" } };
		const fileId = await runAsync(
			async () => {
				return await api.genUvForBoard(param, header);
			},
			{
				error: { content: (err) => `上传图片: ${err.message}` },
				loading: { show: false },
				success: { show: false },
			},
		);
		setUploading(false);
		if (fileId) {
			setUploadFileId(fileId);
		}
		setImgKey(`${new Date().getTime()}`);
	};

	const editorUI = async (file) => {
		const prjId = uvObj.prjId || params.get("prjId");
		const currentFileId = uploadFileId || uvObj.fileId;
		setUploading(true);
		const param = {
			file: file,
			fileId: currentFileId,
			pathName: prjId,
		};
		const { fileId } = await runAsync(
			async () => {
				return await http.upload(param);
			},
			{
				error: { content: (err) => `上传图片: ${err.message}` },
				loading: { show: false },
				success: { show: false },
			},
		);
		setUploading(false);
		if (fileId) {
			setUploadFileId(fileId);
		}
		setImgKey(`${new Date().getTime()}`);
	};

	return (
		<div
			className="preview-image"
			style={noBtns ? { height: "100%", padding: 0 } : {}}
		>
			{(!!uvObj.fileId || uploadFileId) && (
				<div className="draggable-btn" style={{ top: "4px", left: "8px" }}>
					<Button
						size="small"
						loading={uploading}
						onClick={() => handlePasteClick(true)}
					>
						粘贴上传
					</Button>
				</div>
			)}
			{/* 图片预览区域 */}
			<div
				className="left-box"
				style={noBtns ? { border: "none", boxShadow: "none" } : {}}
			>
				{!!uvObj.fileId || uploadFileId ? (
					<img
						key={imgKey}
						className="leftImg-box"
						src={normalizeUrl(
							`/files/${uvObj.fileId || uploadFileId}?_t=${imgKey}`,
						)}
						alt="预览图"
					/>
				) : (
					<div className="no-image">
						{uvObj.uiId && (
							<div className="text-center">
								<div>{uvObj.uiName || ""}</div>

								{!prjPatternId && !noBtns && (
									<>
										<Button
											loading={uploading}
											onClick={handleUpload}
											className="mr-2"
										>
											上传
										</Button>
										<Button
											loading={uploading}
											onClick={() => handlePasteClick(false)}
										>
											粘贴上传
										</Button>
									</>
								)}
							</div>
						)}
					</div>
				)}
			</div>

			{/* 操作按钮区域 */}
			{!noBtns && (
				<div className="right-box">
					{btnLoading ? (
						<Spin size="small" />
					) : actionData.length === 0 ? (
						<div className="no-action">暂无数据</div>
					) : (
						<Tabs
							defaultActiveKey="current"
							style={{ width: "100%" }}
							centered
							items={[
								{
									key: "current",
									label: (
										<span style={{ fontWeight: 600, letterSpacing: "0.5px" }}>
											当前页面事件
										</span>
									),
									children:
										currentPageActions.length > 0 ? (
											renderGroupedActions(currentPageActions)
										) : (
											<div
												className="no-action"
												style={{
													color: "#999",
													padding: "20px",
													textAlign: "center",
												}}
											>
												暂无数据
											</div>
										),
								},
								...(parentActions.length > 0
									? [
											{
												key: "parent",
												label: (
													<span
														style={{ fontWeight: 600, letterSpacing: "0.5px" }}
													>
														父级事件
													</span>
												),
												children: renderGroupedActions(parentActions),
											},
										]
									: []),
							]}
						/>
					)}
				</div>
			)}
			<EventModal ref={modalRef} />
		</div>
	);
};
